// src/GroupIconRenderer.jsx
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './GroupIconRenderer.css'; // Ensure this is imported for styling

const GroupIconRenderer = (props) => {
    let x = (new Date().getTime() -new Date(props.data.last_process_on))/(1000 * 3600 * 24)
    // console.log(x,"KJJJJJJJJJJ");
    const [visibleGroupID, setVisibleGroupID] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
    const iconRef = useRef(null);
    const tooltipRef = useRef(null);

    const style = {
        transit_delay: "#cccc",
        no_gps_data: "#cccc",
        enroute_exception: "#cccc",
        overspeeding_exception: "#cccc",
        nightdriving_exception: "#cccc",
        loading_delay_exception: "#cccc",
        unloading_delay_exception: "#cccc",
        consignment: "#cccc",
        upload_document: "#387ff2",
        view_document:"#cccc"
    }
    if (props?.data?.transit_delay != undefined && props?.data?.transit_delay == 1) {
        console.log(props.data,"MMMMMMMMMMMMMMM");
        style["transit_delay"] = "#FF5370"
        style["consignment"] = "#FF5370"
    }

    if (props?.data?.no_gps_data != undefined && props?.data?.no_gps_data == 1) {
        style["no_gps_data"] = "#FF5370"
        style["consignment"] = "#FF5370"
    }
    if (props?.data?.last_process_on != undefined && ((new Date().getTime() -new Date(props.data.last_process_on))/(1000 * 3600 * 24)) > 1){
        style["no_gps_data"] = "#FF5370"
        style["consignment"] = "#FF5370"
    }
    else if (props?.data?.no_gps_data != undefined && props?.data?.no_gps_data == 0) {
        style["no_gps_data"] = "#26c6da"
        style["consignment"] = "#FF5370"
    }

    if (props?.data?.enroute_exception != undefined && props?.data?.enroute_exception == 1) {
        style["enroute_exception"] = "#a34518"
        style["consignment"] = "#FF5370"
    }
    if (props?.data?.is_submitted_document != undefined && props?.data?.is_submitted_document == 1) {
        style["view_document"] = "#00C292"
        style["consignment"] = "#FF5370"
    }


    // if (props?.data?.overspeeding_exception != undefined && props?.data?.overspeeding_exception == 1) {
    //     style["overspeeding_exception"] = "#3300c2"
    //     style["consignment"] = "#FF5370"
    // }

    // if (props?.data?.nightdriving_exception != undefined && props?.data?.nightdriving_exception == 1) {
    //     style["nightdriving_exception"] = "#ab8ce4"
    //     style["consignment"] = "#FF5370"
    // }

    // if (props?.data?.loading_delay_exception != undefined && props?.data?.loading_delay_exception == 1) {
    //     style["loading_delay_exception"] = "#d3a337"
    //     style["consignment"] = "#FF5370"
    // }

    // if (props?.data?.unloading_delay_exception != undefined && props?.data?.unloading_delay_exception == 1) {
    //     style["unloading_delay_exception"] = "#7ad337"
    //     style["consignment"] = "#FF5370"
    // }

    const handleGroupIconClick = (divID) => {
        if (divID !== null && divID !== undefined) {
            const iconPosition = document.getElementById("rw_" + divID);

            if (!iconPosition) {
                console.error("Element with ID 'rw_" + divID + "' not found");
                return;
            }

            const rect = iconPosition.getBoundingClientRect();

            setTooltipPosition({
                top: rect.bottom + window.scrollY, // Adjusted for better positioning
                left: rect.left + window.scrollX
            });

            setVisibleGroupID((prevID) => (prevID === divID ? null : divID));
        }
    };

    const handleIconClick = (iconType) => {
        switch (iconType) {
            case 'icon1':
                alert('Icon 1 clicked');
                break;
            case 'icon2':
                alert('Icon 2 clicked');
                break;
            case 'icon3':
                alert('Icon 3 clicked');
                break;
            case 'icon4':
                alert('Icon 4 clicked');
                break;
            case 'icon5':
                alert('Icon 5 clicked');
                break;
            case 'icon6':
                alert('Icon 6 clicked');
                break;
            default:
                console.log('Unknown icon type');
        }
    };

    const handleLegsClick = () => {
        // props.onClickShowConsignmentsLegsData(props);
        setVisibleGroupID(null);
    };
    const handleClick = () => {
        props.onShowTransitData(props)
        setVisibleGroupID(null);
    };
    const handleGPSClick = () => {
        if (style.no_gps_data === "#FF5370") {
            return; // Exit the function early if the condition is met
        }
        if (style.no_gps_data === "#26c6da") {
            return; // Exit the function early if the condition is met
        }

    
        props.onShowNoGPSData(props)
        setVisibleGroupID(null);
    };
    const handleOverspeed = () => {
        props.onShowOverspeedingData(props)
        setVisibleGroupID(null);
    };
    const handleNightdriving = () => {
        props.onShowNightDrivingData(props)
        setVisibleGroupID(null);
    };
    const handleStoppage = () => {
        props.onShowStoppagesData(props)
        setVisibleGroupID(null);
    };
    const handleUploadDoc = () => {
        props.onShowUploadDoc(props)
        setVisibleGroupID(null);
    };
    const handleViewDoc = () => {
        props.onShowDocs(props)
        setVisibleGroupID(null);
    };
    const handleDeviation = () => {
        props.onShowTransitData(props)
        setVisibleGroupID(null);
    };
    const handleLoading = () => {
        props.onShowLoadingData(props)
        setVisibleGroupID(null);
    };
    const handleUnloading = () => {
        props.onShowUnloadingData(props)
        setVisibleGroupID(null);
    };

    const handleClickOutside = (event) => {
        if (
            tooltipRef.current &&
            !tooltipRef.current.contains(event.target) &&
            iconRef.current &&
            !iconRef.current.contains(event.target)
        ) {
            setVisibleGroupID(null);
        }
    };
    useEffect(() => {
        if (visibleGroupID !== null) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [visibleGroupID]);

    return (
        <div className="icon-container" ref={iconRef} id={"rw_" + props.node.rowIndex}>
            <span className="group-icon" onClick={() => handleGroupIconClick(props.node.rowIndex)} title="KPIs Status">
                <i className="fa fa-cubes" style={{ color: style.consignment, fontSize:"15px" }}></i>
            </span>
            {visibleGroupID === props.node.rowIndex && ReactDOM.createPortal(
                <div className="tooltip-icons" style={{ top: tooltipPosition.top, left: tooltipPosition.left }} ref={tooltipRef}>
                    {/* <span onClick={handleLegsClick}>
                        <i className="fa fa-sitemap f20"></i>
                    </span> */}
                    <span onClick={handleClick} title="Transit Delay">
                        <i className="icofont icofont-clock-time f20" style={{ color: style.transit_delay }}></i>
                    </span>
                    <span onClick={handleGPSClick} title={props.data.tracking_type === "PTL" ? "Tracking N/A":"Tracking N/A"}>
                        <i className="icofont icofont-social-google-map f20" style={{ color: style.no_gps_data }}></i>
                    </span>
                    {/* <span onClick={handleOverspeed}>
                        <i className="fa fa-tachometer f20" style={{ color: style.overspeeding_exception }}></i>
                    </span>
                    <span onClick={handleNightdriving}>
                        <i className="icofont icofont-full-night f20" style={{ color: style.nightdriving_exception }}></i>
                    </span> */}
                    <span onClick={handleStoppage} title="Stoppages">
                        <i className="icofont icofont-pause f20" style={{ color: style.enroute_exception }}></i>
                    </span>
                    {/* <span onClick={handleUploadDoc} title="Upload Document">
                        <i className="icofont icofont-upload-alt f20" style={{ color: style.upload_document }}></i>
                    </span>
                    <span onClick={handleViewDoc} title="View Documents">
                        <i className="icofont icofont-document-folder f20" style={{ color: style.view_document }}></i>
                    </span> */}
                    {/* <span onClick={handleDeviation}>
                        <i className="fa fa-random f20" style={{ color: style.transit_delay }}></i>
                    </span> */}
                    {/* <span onClick={handleLoading}>
                        <i className="icofont icofont-truck-alt f20" style={{ color: style.loading_delay_exception }}></i>
                    </span>
                    <span onClick={handleUnloading}>
                        <i className="icofont icofont-truck-loaded f20" style={{ color: style.unloading_delay_exception }}></i>
                    </span> */}
                </div>,
                document.body
            )}
        </div>
    );
};

export default GroupIconRenderer;


